import {AuthService, LoyaltyCardService} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import moment from 'moment'

export default {
    name: 'discovery-vitality',

    data () {
        return {
            discovery: {
                day: null,
                month: null,
                year: null,
                number: null,
                name: null,
                email: null,
                gender: null
            },
            months: Utils.MonthMeta(),
            result: null,
            loading: false,
            tried: false,
            success: false,
            status: "",
            tmp_surname: null,
        }
    },

    watch: {
        result: {
            handler(){
                this.tried = true
                if (this.result.data) {
                    this.success = this.result.data.success
                    this.status = this.result.data.response

                    this.$toaster.show(this.status, {
                        top: true,
                        timeout: 1000,
                        primary: true
                    });
                }
                this.loading = false
            },
            deep: true
        },
    },

    computed: {
        currentYear() {
            return moment().format('YYYY')
        }
    },

    methods: {
        onSubmit() {
            this.loading = true
            var dateOfBirth = this.discovery.year + "/" + this.discovery.month + "/" + this.discovery.day;
            Promise.resolve(LoyaltyCardService.activateVitalityCard(dateOfBirth, this.discovery.number, this.discovery.gender, this.discovery.name)).then(
                (activate) => {
                    this.result = activate
                },
                (error) => {
                    Promise.reject(error)
                    this.result = {
                        data: {
                            "success": false,
                            "response": "Hmm, looks like the card number you've entered is invalid. Please double check you’ve entered the right number."
                        }
                    }
                }
            );
        },

        retry() {
            this.tried = false;
        },

        bookNow() {
            this.$router.push(`/`);
        }
    },

    created(){
        this.loading = true;
        AuthService.user().then(user=> {

            if (!user.isGuest()) {
                this.discovery.email = user.Email || null;
                this.discovery.gender = user.Gender && user.Gender == "Unknown" ? "Other" : (user.Gender || null);
                this.discovery.name = user.FirstName.charAt(0);
                this.tmp_surname = user.LastName || null;
                this.discovery.day = user._DobDay || null;
                this.discovery.month = user._DobMonth || null;
                this.discovery.year = user._DobYear || null;
            }
            this.loading = false;

        })
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/discovery-vitality/discovery-vitality.js